import { Assessment } from '$synapse/models';

export interface AssessmentDTO {
  id: string;
  name: string;
  description: string;
  type: string;
  totalQuestions: number;
  hasLesson: boolean;
  isCertifying: boolean;
  status: string;
}

export function mapToAssessment(dto: AssessmentDTO): Assessment {
  return {
    ...dto,
  };
}
